import React from 'react';
import { guarantee } from '../data/tables';
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="bg-paper" data-id="element-125" data-mp="1o3x2hmfkoq20">
      <div className="mx-auto max-w-content px-5 py-16 text-center sm:px-8 md:py-28" data-id="element-126" data-mp="1o5zsw7kn0l79">
        <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full border border-brass/40 bg-sage" data-id="element-127" data-mp="222mz70yhcnpu">
          <span className="max-w-[4rem] font-mono text-[11px] uppercase leading-[1.3] tracking-label text-ink" data-id="element-128" data-mp="19eqvhcahtvjk">
            {guarantee.seal}
          </span>
        </div>

        <h2 id="guarantee-heading" className="mx-auto mt-9 max-w-[32rem] font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-ink md:text-[44px]" data-id="element-129" data-mp="14hh8s4ehnxzf">
          {guarantee.heading}
        </h2>

        <p className="mx-auto mt-5 max-w-[36rem] font-serif text-[22px] italic leading-[1.4] text-brass md:text-[26px]" data-id="element-130" data-mp="qnzo2ga2gf7t">
          {guarantee.highlight}
        </p>

        <p className="mx-auto mt-7 max-w-[640px] text-[17px] leading-[1.65] text-slate" data-id="element-131" data-mp="ln29edo9m3b2">
          {guarantee.body}
        </p>
      </div>
    </section>;
}